export const MIN_CARD_WIDTH_PX = 314;
export const ITEMS_PER_PAGE = 2;
export const ITEMS_PER_PAGE_XS = 1;
export const DEFAULT_PAGE = 0;
